import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import VideoCardList from "./VideoCardList";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import { useState, useEffect } from "react";
import { campaignFetcher, recommenderFetcher } from "../../api/requests";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const SingleVideoRight = () => {
  const [recommendedVideos, setRecommendedVideos] = useState();
  const [error, setError] = useState(null);
  const { id } = useParams();
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");

  useEffect(() => {
    const getRecommendedVideos = async () => {
      try {
        const data = campaignId
          ? await campaignFetcher.getRecomends(Number(id))
          : await recommenderFetcher.get(Number(id));
        setRecommendedVideos(data);
      } catch (err) {
        console.error("Error fetching recommended videos:", err);
        setError("خطا در نمایش ویدئوها");
      }
    };

    getRecommendedVideos();
  }, [id]);

  return (
    <>
      <div className="single-video-right">
        <Row>
          <Col md={12}>
            <SectionHeader heading="پخش بعدی" />
          </Col>
          <Col md={12}>
            {error ? (
              <p>{error}</p>
            ) : recommendedVideos?.results?.length > 0 ? (
              recommendedVideos?.results.map((item, index) => (
                <VideoCardList
                  key={index}
                  imgSrc={item.cover ? item.cover : "/img/v1.png"}
                  time={item.duration}
                  videoTitle={item.title}
                  views={item.counted_views}
                  timeAgo={item.published_date}
                  videoCategory={item.categorys.name}
                  videoHref={`/video-page/${item.id}/`}
                  verified
                  sidebar={true}
                />
              ))
            ) : (
              <p style={{ textAlign: "right" }}>لیست پخش خالی است.</p>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

function AdBlock() {
  return (
    <div className="adblock">
      <div className="img">
        تبلیغات
        <br />
        336 x 280
      </div>
    </div>
  );
}

export default SingleVideoRight;
export { AdBlock };
